import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { TYPES } from 'constants/config';
import * as selectors from 'selectors/pathBuilder';
import ContentWrapper from './Content/Wrapper';
import Content from './Content';
import PathContent from './PathContent';
import HiddenStepsPlaceholder from './HiddenStepsPlaceholder';
import PathRenderer from '../PathBuilder/ContentList/PathRenderer';
import StepsConnector from '../PathBuilder/ContentList/StepsConnector';
import CollapsedContent from './CollapsedContent';

const isCompleted = status => status && status === 'completed';
const awaitingReassignment = content => content.progress.awaitingReassignment;

const showCompleted = content =>
  isCompleted(content.status) && !awaitingReassignment(content);

const collapseContents = (contents, maximumAttemptsEnabled) =>
  contents.reduce((acc, currentContent) => {
    if (showCompleted(currentContent, maximumAttemptsEnabled)) {
      const previousContent = acc.pop();
      if (previousContent && previousContent.type === TYPES.COLLAPSED_CONTENT) {
        previousContent.collapsedContent.push(currentContent);
        acc.push(previousContent);
      } else {
        if (previousContent) {
          acc.push(previousContent);
        }
        acc.push({
          type: TYPES.COLLAPSED_CONTENT,
          collapsedContent: [currentContent],
          totalSteps: contents.length,
          id: currentContent.id,
        });
      }
    } else {
      acc.push(currentContent);
    }
    return acc;
  }, []);

/**
 * Generating a redux-connected path component via PathRenderer
 */
const Path = connect(() => {
  const getStepNumber = selectors.getStepNumber();
  return (state, props) => ({
    stepNumber: getStepNumber(state.pathViewer, props),
  });
})(
  props =>
    new PathRenderer({
      pathComponent: PathContent,
      groupComponent: ContentWrapper,
      startingPosition: props.stepNumber,
      pathData: props,
    }),
);

/**
 * @todo merge all types into into one ContentRenderer component
 */
const typesToComponent = {
  [TYPES.PATH]: Path,
  [TYPES.LESSON]: Content,
  [TYPES.RESOURCE]: Content,
  [TYPES.DEMONSTRATION]: Content,
  [TYPES.COLLAPSED_CONTENT]: CollapsedContent,
};

const renderContent = (isCertification, hasHiddenContents) => content =>
  React.createElement(typesToComponent[content.type], {
    key: `${content.type}.${content.id}`,
    isCertification,
    hasHiddenContents,
    ...content,
  });

const ContentsList = ({
  contents,
  title,
  hasHiddenContents,
  isCertification,
}) => {
  let mappedContents = contents;
  mappedContents = collapseContents(contents);

  return (
    <div className="PathContentsList">
      {mappedContents.map(renderContent(isCertification, hasHiddenContents))}
      {hasHiddenContents && (
        <div className="PathContentWrapper">
          <HiddenStepsPlaceholder pathTitle={title} />
        </div>
      )}
      <StepsConnector />
    </div>
  );
};

const mapStateToProps = state => ({
  title: state.pathViewer.title,
  contents: state.pathViewer.contents,
  hasHiddenContents: state.pathViewer.hiddenContents,
  isCertification: !!get(state, 'pathViewer.badge', false),
});

export default connect(mapStateToProps)(ContentsList);
